<template>
  <v-card class="my-5" outlined v-if="associations.length > 0">
    <AdCardTitle inline>{{ $t('terminology-association') }}</AdCardTitle>
    <v-card-text class="pa-0">
      <v-data-table
        :headers="headers"
        :items="associations"
        item-key="id"
        :no-data-text="$t('no-items')"
        dense
        disable-pagination
        disable-sort
        disable-filtering
        hide-default-footer
        class="elevation-2"
      >
        <template #item.displayName="{ item }">
          <AdButton
            v-if="item.codeSystem && item.code"
            link
            :to="{
              name: 'browser-project-concept',
              params: {
                codeSystemId: item.codeSystem,
                conceptId: item.code
              }
            }"
          >
            {{ item.displayName }}
          </AdButton>
          <template v-else>
            {{ item.displayName }}
          </template>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>

</template>

<script>
export default {
  name: 'TerminologyAssociationCard',
  props: {
    associations: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    headers () {
      return [
        {
          text: this.$t('code'),
          value: 'code',
          width: '8%'
        },
        {
          text: this.$t('display-name'),
          value: 'displayName',
          width: '30%'
        },
        {
          text: this.$t('codesystem'),
          value: 'codeSystemName',
          width: '25%'
        },
        {
          text: this.$t('association-equivalence'),
          value: 'equivalence',
          width: '10%'
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped></style>
